export const REACTIONS_TOP = [
  'heart',
  'thumbs_up',
  'slightly_smiling_face',
  '100',
  'rage',
  'handshake'
];
export const REACTIONS_BOTTOM = [
  'heart_eyes',
  'star_struck',
  'kissing_heart',
  'kissing',
  'relieved',
  'kissing_smiling_eyes',
  'yum',
  'stuck_out_tongue',
  'stuck_out_tongue_winking_eye',
  'stuck_out_tongue_closed_eyes',
  'money_mouth_face',
  'face_with_hand_over_mouth',
  'see_no_evil',
  'saluting_face',
  'hugging_face',
  'face_with_open_eyes_and_hand_over_mouth',
  'shushing_face',
  'thinking',
  'zipper_mouth_face',
  'neutral_face',
  'expressionless',
  'sleepy',
  'unamused',
  'dotted_line_face',
  'smirk',
  'pensive',
  'roll_eyes',
  'grimacing'
];
// Reaction ids (stored by the API) rendered as Unicode emoji
export const REACTION_EMOJI = {
  heart: '❤️',
  thumbs_up: '👍',
  slightly_smiling_face: '🙂',
  100: '💯',
  rage: '😡',
  handshake: '🤝',
  heart_eyes: '😍',
  star_struck: '🤩',
  kissing_heart: '😘',
  kissing: '😗',
  relieved: '😌',
  kissing_smiling_eyes: '😙',
  yum: '😋',
  stuck_out_tongue: '😛',
  stuck_out_tongue_winking_eye: '😜',
  stuck_out_tongue_closed_eyes: '😝',
  money_mouth_face: '🤑',
  face_with_hand_over_mouth: '🤭',
  see_no_evil: '🙈',
  saluting_face: '🫡',
  hugging_face: '🤗',
  face_with_open_eyes_and_hand_over_mouth: '🫢',
  shushing_face: '🤫',
  thinking: '🤔',
  zipper_mouth_face: '🤐',
  neutral_face: '😐',
  expressionless: '😑',
  sleepy: '😪',
  unamused: '😒',
  dotted_line_face: '🫥',
  smirk: '😏',
  pensive: '😔',
  roll_eyes: '🙄',
  grimacing: '😬'
};
